const SHORT_ID_LENGTH = 6;

export const getShortId = (id?: string | null): string => (id ? id.slice(0, SHORT_ID_LENGTH) : '');
